import React from 'react';
import cn from 'classnames';
import styles from './HeadingBlock.module.scss';
import PopoverRegistrationAll from '../PopoverRegistrationAll/PopoverRegistrationAll';

const HeadingBlock = ({ currentCompany, name, title, subtitle, wrapClassName, inline = false }) => {

  if (name) {
    return (
      <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
        <div className={cn(wrapClassName, { [styles.rootInline]: inline })}>
      {title && (
        <h2 className={cn(styles.title, { [styles.titleInline]: inline })}>
          {title}
        </h2>
      )}
      {subtitle && (
        <p className={cn(styles.subtitle, { [styles.subtitleInline]: inline })}>
          {inline && '— '}
          {subtitle}
        </p>
      )}
        </div>
        <PopoverRegistrationAll currentCompany={currentCompany} />
      </div>
    )
  }
  
  return (
    <div className={cn(wrapClassName, { [styles.rootInline]: inline })}>
      {title && (
        <h2 className={cn(styles.title, { [styles.titleInline]: inline })}>
          {title}
        </h2>
      )}
      {subtitle && (
        <p className={cn(styles.subtitle, { [styles.subtitleInline]: inline })}>
          {inline && '— '}
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default HeadingBlock;
